import React from 'react';
import { PerformanceSchedulesSearch } from 'components';

export const PerformanceSchedulesPage = () => {
    return <PerformanceSchedulesSearch />;
};
